import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import CalloutSchema from './schema';
import CalloutView from './CalloutView';
import type { CalloutData } from './CalloutView';

type CalloutEditProps = {
  data: CalloutData;
  block: string;
  selected: boolean;
  onChangeBlock: (block: string, data: CalloutData) => void;
};

const CalloutEdit = (props: CalloutEditProps) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const schema = CalloutSchema({ intl });

  return (
    <>
      <CalloutView data={data} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id: string, value: unknown) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default CalloutEdit;
